<!-- 手动办理入职 -->
<template>

  <div id="inputForm">
    <div>
      <!-- 标题 道远咨询个人信息登记表 -->
      <div v-if="!isEdit" class="topTitle">
        {{ $t('datapermission.induction.registrationForm') }}—{{ $t('keyshenzhen') }}
      </div>

      <a-form-model  :style=" isEdit ? 'width: 832px' : ''" :model="form" ref="ruleForm" layout="vertical">

        <!-- 基本资料 ---------------------------------------------------------------------------------------------------------------------->
        <div
          style="width: 100%;height: 50px;background: rgba(244,245,248,0.4);margin-top: 14px;margin-bottom: 30px;border: 1px solid #E9E9E9;display: flex;flex-direction: row;align-items: center">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px">
            {{ $t('datapermission.induction.basicInformation') }}
          </div>
        </div>

        <!-- 个人照片 -->

        <a-row>
          <a-col :span="18">
            <a-row class="backgroundTop" :gutter="16">

              <!-- 姓名 -->
              <a-col :span="8">
                <a-form-model-item prop="inductionInvitationDO.name"  class="required"
                                   :label="$t('datapermission.induction.name')">
                  <div class="text_value" v-text="form.inductionInvitationDO.name"
                           :placeholder="$t('datapermission.induction.tips.input')"></div>
                </a-form-model-item>
              </a-col>
              <!-- 英文名 -->
              <a-col :span="8">
                <a-form-model-item prop="inductionBasicDO.nameEn"
                                   :label="$t('datapermission.induction.inductionBasic.nameEn')"
                                   class="required"  >
                  <div  class="text_value" v-text="form.inductionBasicDO.nameEn"
                           :placeholder="$t('datapermission.induction.tips.input')"></div>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <!-- 所属公司-->
                <a-form-model-item prop="inductionInvitationDO.companyId"  class="required" :label="$t('datapermission.induction.company')">
                  <!--  <pt-filter-company-select v-model="companyId"
                                              @select="getCompany"
                                              @change="()=>{this.queryVO.accountId = undefined;this.changeQuery()}">
                    </pt-filter-company-select>-->
                  <div  class="text_value" v-text="userInfo.companyName"></div>
                </a-form-model-item>
              </a-col>
              <!-- 所属部门 -->
              <a-col :span="8">
                <a-form-model-item   prop="inductionInvitationDO.departmentId"  class="required"
                                   :label="$t('datapermission.induction.department')">
                  <div  class="text_value" v-text="userInfo.depName"></div>
                </a-form-model-item>
              </a-col>

              <!-- 职位 -->
              <a-col :span="8">
                <a-form-model-item   prop="inductionInvitationDO.postId"   class="required" :label="$t('datapermission.induction.post')">
                  <div  class="text_value">{{userInfo.postName}}</div>
                </a-form-model-item>
              </a-col>

              <!-- 入职时间 -->
              <a-col :span="8">
                <a-form-model-item prop="emoloyeeVO.entrytime"   class="required"
                                   :label="$t('user.tableHeader.entrytime')">
                  <div  class="text_value">{{userInfo.entrytime}}</div>
                </a-form-model-item>
              </a-col>
              <!-- 最高学历 -->
              <a-col :span="8">
                <a-form-model-item class="required" :rules="[{required: true,message:$t('common.selectHighestEducation'),trigger:'change'}]"
                                   prop="inductionBasicDO.highestEducation"
                                   :label="$t('datapermission.induction.inductionBasic.highestEducation')">
                  <pt-select
                    autocomplete="off"
                    :placeholder="$t('datapermission.induction.tips.choice')"
                    v-model="form.inductionBasicDO.highestEducation"
                  >
                    <a-select-option v-for="item in $t('user.educations')" :key="item.name" :disabled="item.name == '专科/本科'" :value="item.name">{{ item.name }}
                    </a-select-option>
                  </pt-select>
                </a-form-model-item>
              </a-col>




              <!-- 生日 -->
              <a-col :span="8">
                <a-form-model-item prop="inductionBasicDO.birthday"
                                   :label="$t('datapermission.induction.inductionBasic.birthday')" class="required"
                                   :rules="[
                      {required: true,message:$t('keyqingxuanzeriqi'),trigger:'change'}
                    ]">
                  <a-date-picker @change="onChangeBirthday"
                                 value-format="YYYY-MM-DD"
                                 :placeholder="$t('datapermission.induction.tips.choiceDate')"
                                 v-model="form.inductionBasicDO.birthday"
                                 style="width: 100%"></a-date-picker>

                </a-form-model-item>
                <!--是否阴历 -->
                <a-checkbox :checked="isLunarCalendar" @change="onChangeBox"
                            style="position: absolute;bottom: 65px;left: 60px">
                  {{ $t('datapermission.induction.inductionBasic.lunarCalendar') }}
                </a-checkbox>
              </a-col>


              <a-col :span="8">
                <!-- 性别 -->
                <a-form-model-item  prop="inductionInvitationDO.sex" :rules="[
                                     {required:true,message:$t('baseVO.selectPlaceholder'),trigger:'change'}
                                   ]" class="required" :label="$t('user.tableHeader.sex')">
                  <pt-select
                    :placeholder="$t('user.modal.tips.sex')"
                    v-model="form.inductionInvitationDO.sex">
                    <a-select-option v-for="sex in sexs" :key="sex.value" :value="sex.value">{{ sex.name }}
                    </a-select-option>
                  </pt-select>
                </a-form-model-item>
              </a-col>


            </a-row>


          </a-col>
          <a-col :span="6" style="display: flex;justify-content: center;align-items: center">
            <div>
              <a-form-model-item :colon="false" :label="$t('key74')" class="required" :rules="[
                                    {required:true,message:$t('mansion.options.files'),trigger:'blur'}
                                  ]" prop="outImage">
                <oss-upload :fixed-number="[16,16]" :multiple="false" :is-cropper="true" fileSuffix="png,jpg,jpeg"
                            @onSuccess="uploadImgSuccess" :number="1">
                  <div class="operationDivs" style="margin-top: 10px;">
                    <div style="position: relative;border-radius: 50%">
<!--                      <img :src="getImageUrl(outImage.fileId)"-->
<!--                          -->
<!--                           style="width: 176px;height: 176px;border-radius: 50%">-->
                      <a-avatar  v-if="outImage && outImage.fileId && this.form.outImage!='~'" icon="user" :size="176" :src="getImageUrl(outImage.fileId)" />
                      <!--<div style="position: absolute;width: 100%;height: 30px;display: flex;justify-content: center;align-content: center;background-color: rgba(0,0,0,0.4)">
                        <pt-icon type="icon-tubiao"></pt-icon>
                      </div>-->
                      <div v-else
                           style="width: 176px;height: 176px;display: flex;justify-content: center;align-items: center;background: #D8D8D8;border-radius: 50%;">
                        <div>
                          <pt-icon type="icon-zengjia" style="font-size: 30px;color: #fff"></pt-icon>
                          <div style="font-size: 12px;color: #999999;margin-top: 15px;">
                            {{ $t('datapermission.induction.tips.personImg') }}
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </oss-upload>
              </a-form-model-item>
            </div>
          </a-col>
        </a-row>
        <a-row class="backgroundTop" :gutter="16">


          <!-- 汇报对象 -->
          <a-col :span="6">
            <a-form-model-item prop="emoloyeeVO.reporter" class="required"
                               :label="$t('user.modal.leader')">
             <div  class="text_value">{{userInfo.reporterName}}</div>
            </a-form-model-item>
          </a-col>
          <!-- 合同到期日 -->
          <a-col :span="6">
            <a-form-model-item prop="emoloyeeVO.contractExpiry" class="required"
                               :label="$t('user.tableHeader.contractExpiry')">
<!--              <a-date-picker style="width: 100%" value-format="YYYY-MM-DD" :allow-clear="false"-->
<!--                             v-model="form.emoloyeeVO.contractExpiry"></a-date-picker>-->
              <div  class="text_value">
                <a-tooltip v-if="getArrayList(userInfo.trialdate) != '~'" :title="getArrayList(userInfo.trialdate)" placement="top">
                  {{getArrayList(userInfo.trialdate)}}
                </a-tooltip>
                <span v-else>{{getArrayList(userInfo.trialdate)}}</span>
              </div>

            </a-form-model-item>
          </a-col>

          <!-- 合同到期日 -->
          <a-col :span="6">
            <a-form-model-item prop="emoloyeeVO.trialdate"
                               :label="$t('user.tableHeader.trialdate')">
<!--              <a-range-picker style="width: 100%"  value-format="YYYY-MM-DD" :allow-clear="false"-->
<!--                              v-model="form.emoloyeeVO.trialdate"></a-range-picker>-->
              <div  class="text_value">
                {{userInfo.contractExpiry}}
              </div>
            </a-form-model-item>
          </a-col>


          <!-- 合同到期日 -->
          <a-col :span="6">
            <a-form-model-item prop="emoloyeeVO.practicedate"
                               :label="$t('user.tableHeader.practicedate')">
<!--              <a-range-picker style="width: 100%"  value-format="YYYY-MM-DD" :allow-clear="false"-->
<!--                              v-model="form.emoloyeeVO.practicedate"></a-range-picker>-->
              <div  class="text_value">
                <a-tooltip v-if="getArrayList(userInfo.practicedate) != '~'" :title="getArrayList(userInfo.practicedate)" placement="top">
                  {{getArrayList(userInfo.practicedate)}}
                </a-tooltip>
                <span v-else>{{getArrayList(userInfo.practicedate)}}</span>
              </div>

            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <!-- 证件类型 -->
          <a-col :span="6">
            <a-form-model-item class="required" :rules="[{required: true,message:$t('common.selectIDType'),trigger:'change'}]"
                               prop="inductionBasicDO.idType"
                               :label="$t('datapermission.induction.inductionBasic.idType')">
              <pt-select
                autocomplete="off"
                :placeholder="$t('datapermission.induction.tips.choice')"
                v-model="form.inductionBasicDO.idType"
              >
                <a-select-option v-for="(item,index) in idTypes" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>

          <!-- 证件号码 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionBasicDO.idNumber"
                               :label="$t('datapermission.induction.inductionBasic.idNumber')"
                               class="required" :rules="[{required: true,message:$t('common.enterIDNumber'),trigger:'blur'}]">
              <a-input v-model="form.inductionBasicDO.idNumber"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>

          <!-- 民族 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionBasicDO.nation"
                               :label="$t('datapermission.induction.inductionBasic.nation')"
                               class="required" :rules="[{required: true,message:$t('common.enterEthnicity'),trigger:'blur'}]">
              <a-input v-model="form.inductionBasicDO.nation"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>

          <!-- 手机号码 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionBasicDO.phoneNumber"
                               :label="$t('datapermission.induction.inductionBasic.phoneNumber')"
                               class="required" :rules="[{required: true,message:$t('user.modal.tips.phone'),trigger:'blur'}]">
              <a-input-number v-model="form.inductionBasicDO.phoneNumber"
                              :placeholder="$t('datapermission.induction.tips.input')"
                              style="width: 100%"></a-input-number>
            </a-form-model-item>
          </a-col>

          <!-- 工资卡-开户银行 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionTreatmentDO.bank"
                               :label="$t('datapermission.induction.inductionTreatment.bank')">
              <a-input v-model="form.inductionTreatmentDO.bank"
                       :placeholder="$t('datapermission.induction.tips.merchantsBank')"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- 开户地 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionTreatmentDO.bankAddress"
                               :label="$t('datapermission.induction.inductionTreatment.bankAddress')">
              <a-input v-model="form.inductionTreatmentDO.bankAddress"
                       :placeholder="$t('datapermission.induction.tips.example')"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- 银行账户 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionTreatmentDO.bankNumber"
                               :label="$t('datapermission.induction.inductionTreatment.bankNumber')">
              <a-input v-model="form.inductionTreatmentDO.bankNumber"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <div v-if="isShowAll || isShowDetail"
          style="width: 100%;height: 50px;background: rgba(244,245,248,0.4);margin-top: 14px;margin-bottom: 30px;border: 1px solid #E9E9E9;display: flex;flex-direction: row;align-items: center">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px">
            {{ $t('datapermission.detailInfo') }}
          </div>
        </div>

        <a-row class="backgroundTop" v-if="isShowAll || isShowDetail" :gutter="16">

          <!-- 婚姻状况 -->
          <a-col :span="6">
            <a-form-model-item class="required" :rules="[{required: true,message:$t('common.selectMaritalStatus'),trigger:'change'}]"
                               prop="inductionBasicDO.maritalStatus"
                               :label="$t('datapermission.induction.inductionBasic.maritalStatus')">
              <pt-select
                autocomplete="off"
                :placeholder="$t('datapermission.induction.tips.choice')"
                v-model="form.inductionBasicDO.maritalStatus"
              >
                <a-select-option v-for="(item,index) in maritalStatuses" :key="item.id" :value="item.wordKey">{{ item.wordValue }}
                </a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>

          <!-- 生育状况 -->
          <a-col :span="6">
            <a-form-model-item class="required" :rules="[{required: true,message:$t('common.selectParentalStatus'),trigger:'change'}]"
                               prop="inductionBasicDO.fertilityStatus"
                               :label="$t('datapermission.induction.inductionBasic.fertilityStatus')">
              <pt-select
                autocomplete="off"
                :placeholder="$t('datapermission.induction.tips.choice')"
                v-model="form.inductionBasicDO.fertilityStatus"
              >
                <a-select-option v-for="(item,index) in fertilityStatuses" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>

          <!-- 健康状况 -->
          <a-col :span="6">
            <a-form-model-item class="required" :rules="[{required: true,message:$t('common.selectHealthStatus'),trigger:'change'}]"
                               prop="inductionBasicDO.healthStatus"
                               :label="$t('datapermission.induction.inductionBasic.healthStatus')">
              <pt-select
                autocomplete="off"
                :placeholder="$t('datapermission.induction.tips.choice')"
                v-model="form.inductionBasicDO.healthStatus"
              >
                <a-select-option v-for="(item,index) in healthStatuses" :key="item.id" :value="parseInt(item.wordKey)">{{ item.wordValue }}
                </a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>


          <!-- 籍贯 -->
          <a-col :span="6">
            <a-form-model-item class="required" :rules="[{required: true,message:$t('common.selectPlaceOfOrigin'),trigger:'change'}]"
                               prop="inductionBasicDO.nativePlace"
                               :label="$t('datapermission.induction.inductionBasic.nativePlace')">
              <pt-select
                autocomplete="off"
                :placeholder="$t('datapermission.induction.tips.choice')"
                v-model="form.inductionBasicDO.nativePlace"
              >
                <a-select-option v-for="(item,index) in natives" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>

          <!-- 户籍类型 -->
          <a-col :span="6">
            <a-form-model-item class="required" :rules="[{required: true,message:$t('common.selectHouseholdRegistrationType'),trigger:'change'}]"
                               prop="inductionBasicDO.registeredType"
                               :label="$t('datapermission.induction.inductionBasic.registeredType')">
              <pt-select
                autocomplete="off"
                :dropdownMatchSelectWidth="false"
                :placeholder="$t('datapermission.induction.tips.choice')"
                v-model="form.inductionBasicDO.registeredType"
              >
                <a-select-option v-for="(item,index) in registeredTypes" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>


          <!-- 人员类型 -->
          <a-col :span="6">
            <a-form-model-item class="required" :rules="[{required: true,message:$t('common.selectEmployeeCategory'),trigger:'change'}]"
                               prop="inductionBasicDO.personnelType"
                               :label="$t('datapermission.induction.inductionBasic.personnelType')">
              <pt-select
                autocomplete="off"
                :placeholder="$t('datapermission.induction.tips.choice')"
                v-model="form.inductionBasicDO.personnelType"
              >
                <a-select-option v-for="(item,index) in personneslTypesSelect" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>

          <!-- 毕业学校 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionBasicDO.graduationSchool"
                               :label="$t('datapermission.induction.inductionBasic.graduationSchool')"
                               class="required" :rules="[{required: true,message:$t('common.enterSchoolGraduatedFrom'),trigger:'blur'}]">
              <a-input v-model="form.inductionBasicDO.graduationSchool"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>

          <!-- 专业 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionBasicDO.major"
                               :label="$t('datapermission.induction.inductionBasic.major')"
                               class="required" :rules="[{required: true,message:$t('common.enterMajor'),trigger:'blur'}]">
              <a-input v-model="form.inductionBasicDO.major"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>

          <!-- 首次参加工作时间 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionBasicDO.firstWorkingDate"
                               :label="$t('datapermission.induction.inductionBasic.firstWorkingDate')">
              <a-month-picker style="width: 100%" @change="firstWorkingDateChange" value-format="YYYY-MM"
                             :placeholder="$t('datapermission.induction.tips.choiceDate')"
                             v-model="form.inductionBasicDO.firstWorkingDate"></a-month-picker>
            </a-form-model-item>
          </a-col>

          <!-- 执业资格 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionBasicDO.practiceQualification"
                               :label="$t('datapermission.induction.inductionBasic.practiceQualification')">
              <a-input v-model="form.inductionBasicDO.practiceQualification"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>

          <!-- 专业职称 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionBasicDO.professionalTitle"
                               :label="$t('datapermission.induction.inductionBasic.professionalTitle')">
              <a-input v-model="form.inductionBasicDO.professionalTitle"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>

          <!-- 身份证地址（户口所在地） -->
          <a-col :span="12">
            <a-form-model-item prop="inductionBasicDO.registeredAddress"
                               :label="$t('datapermission.induction.inductionBasic.registeredAddress')"
                               class="required" :rules="[{required: true,message:$t('common.enterRegisteredAddress'),trigger:'blur'}]">
              <a-input v-model="form.inductionBasicDO.registeredAddress"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- 现居住的详细地址 -->
          <a-col :span="12">
            <a-form-model-item prop="inductionBasicDO.addressNow"
                               :label="$t('datapermission.induction.inductionBasic.addressNow')"
                               class="required" :rules="[{required: true,message:$t('common.enterCurrentAddress'),trigger:'blur'}]">
              <a-input v-model="form.inductionBasicDO.addressNow"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- 其他证书 -->
          <a-col :span="12"  >
            <a-form-model-item
              prop="inductionBasicDO.certificate"
              :label="$t('datapermission.induction.inductionBasic.certificate')">
              <a-input
                autocomplete="off"
                :placeholder="$t('baseVO.inputPlaceholder')"
                v-model="form.inductionBasicDO.certificate"
              >
              </a-input>
            </a-form-model-item>
          </a-col>
          <!-- 健康状况 -->
          <a-col :span="12" v-if="form.inductionBasicDO.healthStatus == 3">
            <a-form-model-item class="required" :rules="[{required: true,message:$t('common.enterSpecialHealthInformation'),trigger:'change'}]"
                               prop="inductionBasicDO.healthStatusRemarks"
                               :label="$t('datapermission.induction.inductionBasic.healthStatusRemark')">
              <a-input
                autocomplete="off"
                :placeholder="$t('datapermission.induction.tips.healthStatusRemark')"
                v-model="form.inductionBasicDO.healthStatusRemarks"
              >
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- 社保/公积金/工资 ---------------------------------------------------------------------------------------------------------------------->
        <div v-if="false"
          style="width: 100%;height: 50px;background: rgba(244,245,248,0.4);margin-top: 14px;margin-bottom: 30px;border: 1px solid #E9E9E9;display: flex;flex-direction: row;align-items: center">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px">
            {{ $t('datapermission.induction.treatmentInformation') }}
          </div>
        </div>


        <a-row class="backgroundTop" :gutter="16" style="margin-top: 26px" v-if="false">
          <!-- 基本工资 -->
          <a-col :span="6">
            <a-form-model-item  class="required" :rules="[{required: true,message: $t('user.modal.tips.basepay'),}]"
                          :label="$t('user.tableHeader.basepay')">
              <pt-input-number style="width: 100%;" v-model="form.emoloyeeVO.basepay"  :precision="2" :min="0"
                               autocomplete="off"
                               @change="salaryChange"
                               :placeholder="$t('user.modal.tips.basepay')">
              </pt-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :span="6"    v-if="show">
            <a-form-model-item class="required"
                         :rules="[ {required: true,message: $t('user.modal.tips.useStartDate'),}]"
                         :label="$t('user.tableHeader.useStartDate')">
              <pt-date-picker style="width: 100%" v-model="form.emoloyeeVO.useStartDate"  :placeholder="$t('user.modal.tips.useStartDate')"
                autocomplete="off" value-format="YYYY-MM-DD">
              </pt-date-picker>
            </a-form-model-item>
          </a-col>
          <!-- 社保电脑号 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionTreatmentDO.socialSecurityNumber"
                               :label="$t('datapermission.induction.inductionTreatment.socialSecurityNumber')">
              <a-input v-model="form.inductionTreatmentDO.socialSecurityNumber"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item  class="required"
                                :rules="[ {required: true,message: $t('user.modal.tips.insuranceBase'),}]"
                          :label="$t('user.tableHeader.insuranceBase')">
              <pt-input-number style="width: 100%;"  :precision="2" :min="0" v-model="form.emoloyeeVO.insuranceBase"
                               autocomplete="off"
                               :placeholder="$t('user.modal.tips.insuranceBase')">
              </pt-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item  class="required" :rules="[ {required: true,message: $t('user.modal.tips.unemploymentInsuranceBase'),}]"
                          :label="$t('user.tableHeader.unemploymentInsuranceBase')">
              <pt-input-number style="width: 100%;"  :precision="2" :min="0"
                               autocomplete="off"
                               :placeholder="$t('user.modal.tips.unemploymentInsuranceBase')"
                               v-model="form.emoloyeeVO.unemploymentInsuranceBase">
              </pt-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item  class="required"
                                :rules="[ {required: true,message: $t('user.modal.tips.brokerageId'),}]"
                          :label="$t('user.tableHeader.brokerageId')">
              <pt-select
                autocomplete="off"
                v-model="form.emoloyeeVO.brokerageId"
                :placeholder="$t('user.modal.tips.brokerageId')">
                <a-select-option v-for="item in brokerages" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>
          <!-- 公积金账户 -->
          <a-col :span="6">
            <a-form-model-item prop="inductionTreatmentDO.accumulationFundNumber"
                               :label="$t('datapermission.induction.inductionTreatment.accumulationFundNumber')">
              <a-input v-model="form.inductionTreatmentDO.accumulationFundNumber"
                       :placeholder="$t('datapermission.induction.tips.input')"></a-input>
            </a-form-model-item>
          </a-col>

        </a-row>


        <!-- 主要教育经历 ---------------------------------------------------------------------------------------------------------------------->
        <div v-if="isShowAll"
          style="width: 100%;height: 50px;background: rgba(244,245,248,0.4);margin-top: 14px;margin-bottom: 30px;border: 1px solid #E9E9E9;display: flex;flex-direction: row;align-items: center">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px">
            {{ $t('datapermission.induction.educationInformation') }}
          </div>
        </div>

        <div style="margin-top: 26px" v-if="isShowAll">
          <a-row class="backgroundTop" :gutter="16" v-for="(item,index) in form.inductionEducationList" :key="index">
            <!-- 时间 -->
            <a-col :span="6">
              <a-form-model-item :prop="'inductionEducationList.'+index+'.educationDate'"
                                 :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('mansion.addMansion.placeholder.trafficInfo.passByCar'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionEducation.educationDate'):''">
                <a-range-picker v-model='educationDate[index]' @change="onChangeDate(index)" valueFormat="YYYY-MM-DD" />
              </a-form-model-item>

            </a-col>
            <!-- 学校 -->
            <a-col :span="6">
              <a-form-model-item :prop="'inductionEducationList.'+index+'.school'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('common.enterSchool'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionEducation.school'):''">
                <a-input v-model="item.school"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>
            </a-col>
            <!-- 专业 -->
            <a-col :span="6">
              <a-form-model-item :prop="'inductionEducationList.'+index+'.major'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('common.enterMajor'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionEducation.major'):''">
                <a-input v-model="item.major"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>
            </a-col>
            <!-- 学历 -->
            <a-col :span="6">
              <a-form-model-item :prop="'inductionEducationList.'+index+'.education'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('common.enterEducation'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionEducation.education'):''">
                <a-input v-model="item.education"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>
              <pt-icon @click.native="deleteEducation(index)" v-if="index!=0"
                       style="position: absolute;bottom: 38px;right: -20px;font-size: 20px" type="icon-tubiao"/>
            </a-col>
          </a-row>
          <!-- 新增一行按钮 -->
          <a-button @click="addEducation" style="margin-right: 10px;">
            <pt-icon type="icon-zengjia" style="color:  #A0A0A0;"/>
            {{ $t('datapermission.induction.addRow') }}
          </a-button>
        </div>


        <!-- 主要工作经历 ---------------------------------------------------------------------------------------------------------------------->
        <div v-if="isShowAll"
          style="width: 100%;height: 50px;background: rgba(244,245,248,0.4);margin-top: 50px;margin-bottom: 30px;border: 1px solid #E9E9E9;display: flex;flex-direction: row;align-items: center">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px">
            {{ $t('datapermission.induction.workInformation') }}
            <span style="font-size: 12px !important;padding-left: 20px;color: #999">{{$t('datapermission.induction.workInformationTip') }}</span>
          </div>
        </div>

        <div style="margin-top: 26px" v-if="isShowAll">
          <a-row class="backgroundTop" :gutter="16" v-for="(item,index) in form.inductionWorkList" :key="index">
            <!-- 时间 -->
            <a-col :span="6">
              <a-form-model-item :prop="'inductionWorkList.'+index+'.workDate'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('mansion.addMansion.placeholder.trafficInfo.passByCar'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionWork.workDate'):''">
                <a-input v-model="item.workDate"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>

            </a-col>
            <!-- 单位 -->
            <a-col :span="6">
              <a-form-model-item :prop="'inductionWorkList.'+index+'.companyName'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('common.enterEmployer'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionWork.companyName'):''">
                <a-input v-model="item.companyName"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>
            </a-col>
            <!-- 部门 -->
            <a-col :span="3">
              <a-form-model-item :prop="'inductionWorkList.'+index+'.department'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('common.enterDepartment'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionWork.department'):''">
                <a-input v-model="item.department"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>
            </a-col>
            <!-- 职务 -->
            <a-col :span="3">
              <a-form-model-item :prop="'inductionWorkList.'+index+'.post'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('common.enterJobTitle'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionWork.post'):''">
                <a-input v-model="item.post"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>
            </a-col>
            <!-- 证明人/联系方式 -->
            <a-col :span="6">
              <a-form-model-item :prop="'inductionWorkList.'+index+'.witnessContact'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('common.enterRefereeContact'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionWork.witnessContact'):''">
                <a-input v-model="item.witnessContact"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>
              <pt-icon @click.native="deleteWork(index)" v-if="index!=0"
                       style="position: absolute;bottom: 38px;right: -20px;font-size: 20px" type="icon-tubiao"/>
            </a-col>
          </a-row>
          <!-- 新增一行按钮 -->
          <a-button @click="addWork" style="margin-right: 10px;">
            <pt-icon type="icon-zengjia" style="color:  #A0A0A0;"/>
            {{ $t('datapermission.induction.addRow') }}
          </a-button>
        </div>

        <!-- 家庭成员 ---------------------------------------------------------------------------------------------------------------------->
        <div v-if="isShowAll"
          style="width: 100%;height: 50px;background: rgba(244,245,248,0.4);margin-top: 50px;margin-bottom: 30px;border: 1px solid #E9E9E9;display: flex;flex-direction: row;align-items: center">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px">
            {{ $t('datapermission.induction.familyInformation') }}
          </div>
        </div>

        <div style="margin-top: 26px" v-if="isShowAll">
          <a-row class="backgroundTop" :gutter="16" v-for="(item,index) in form.inductionFamily" :key="index">
            <!-- 姓名 -->
            <a-col :span="6">
              <a-form-model-item :prop="'inductionFamily.'+index+'.name'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('linkman.modal.nameCNTip'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionFamily.name'):''">
                <a-input v-model="item.name"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>

            </a-col>
            <!-- 关系 -->
            <a-col :span="3">

              <a-form-model-item :prop="'inductionFamily.'+index+'.relationship'"
                                 :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('common.enterRelationship'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionFamily.relationship'):''">
                <pt-select
                  autocomplete="off"
                  :placeholder="$t('datapermission.induction.tips.choice')"
                  v-model="item.relationship"
                >
                  <a-select-option v-for="item in relationships" :key="item.id" :value="item.wordKey">{{ item.wordValue }}
                  </a-select-option>
                </pt-select>
              </a-form-model-item>
            </a-col>
            <!-- 工作单位 -->
            <a-col :span="6">
              <a-form-model-item :prop="'inductionFamily.'+index+'.companyPost'"
                                 :label="index==0?$t('datapermission.induction.inductionFamily.companyPost'):''">
                <a-input v-model="item.companyPost"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>
            </a-col>
            <!-- 联系方式 -->
            <a-col :span="5">
              <a-form-model-item :prop="'inductionFamily.'+index+'.contactInformation'" :class="index==0?'required':''"
                                 :rules="index==0?[{required: true,message:$t('common.enterContactDetails'),trigger:'blur'}]:[]"
                                 :label="index==0?$t('datapermission.induction.inductionFamily.contactInformation'):''">
                <a-input v-model="item.contactInformation"
                         :placeholder="$t('datapermission.induction.tips.input')"></a-input>
              </a-form-model-item>
            </a-col>
            <!-- 紧急联系人 -->
            <a-col :span="4">
              <a-form-model-item :prop="'inductionFamily.'+index+'.emergencyContact'" :class="index==0?'required':''"
                                 :label="index==0?$t('datapermission.induction.inductionFamily.emergencyContact'):''"
                                 style="width: 100%">
                <div style="display: flex;align-items: center;justify-content: center">
                  <a-radio :checked="item.emergencyContact == 1" @click="changContact(index)" style="margin-top: 8px"/>
                </div>

              </a-form-model-item>
              <pt-icon @click.native="deleteFamily(index)" v-if="index!=0"
                       style="position: absolute;bottom: 32px;right: -20px;font-size: 20px" type="icon-tubiao"/>
            </a-col>
          </a-row>

          <!-- 新增一行按钮 -->
          <a-button @click="addFamily" style="margin-right: 10px;">
            <pt-icon type="icon-zengjia" style="color:  #A0A0A0;"/>
            {{ $t('datapermission.induction.addRow') }}
          </a-button>
        </div>
        <!-- 特别说明 ---------------------------------------------------------------------------------------------------------------------->
        <div
          style="width: 100%;height: 50px;background: rgba(244,245,248,0.4);margin-top: 50px;margin-bottom: 30px;border: 1px solid #E9E9E9;display: flex;flex-direction: row;align-items: center">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px">
            {{ $t('datapermission.induction.specialNote') }}
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="font-size: 12px;color: #999999;letter-spacing: 0;">
            {{$t('datapermission.induction.remarks')}}
          </div>
          <div style="margin-left: 50px">
            <a-radio-group v-model="form.inductionInvitationDO.isPeer">
              <a-radio :value="1">{{$t('mansion.deleteMansionOwnerModal.button.yes')}}</a-radio>
              <a-radio :value="2">{{$t('mansion.deleteMansionOwnerModal.button.no')}}</a-radio>
            </a-radio-group>
          </div>
        </div>
        <!-- 特别说明 -->
        <a-form-model-item prop="specialNote">

          <a-textarea v-model="form.inductionInvitationDO.specialNote"
                      :placeholder="$t('datapermission.induction.tips.specialNoteTips')" :rows="4"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>


</template>

<script>
import DepApi from '@/api/sys/organization'
import PostApi from '@/api/sys/post'
import Api from '@/api/sys/inductionInvitation'
import {getInductionDatadic} from '@/api/sys/datadict'
import OssUpload from '@/components/upload/ossUpload'
import moment from 'moment'
import BrokerageApi from '@/api/manager/personSetting/brokerage'


export default {
  name: 'inputForm',
  components: {
    OssUpload
  },
  props: {
    ownEdit:{

      type:Boolean,
      default:false,
    },
    isOut: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default:{}
    },
    isEdit: {
      type: Boolean,
      default: false
    },
  },

  data() {
    let vm = this
    return {
      educationDate:[],
      companyId: undefined,
      depId: '',
      isLunarCalendar: false,
      postId: undefined,
      posts: [],
      deps: [],
      checkedListTwo: [],
      checkedListOne: [],
      inductionBasicImage: [],
      changDeclare: false,
      changeMergency: [],
      inductionInfo:{

      },
      form: {
        emoloyeeVO:{
          entrytime:'',
          contractExpiry:'',
          trialdate:[],
          practicedate:[],
          reporter:'',
        },
        outImage: '',
        inductionInvitationDO: {
          name:'',
          sex:'',
          isPeer:2,
          companyId:'',
          departmentId:'',
          postId:'',
        },
        inductionBasicDO: {
          nameEn:'',
          highestEducation:'',
          birthday:'',
          lunarCalendar:0,
          idType:1,
          idNumber:undefined,
          nation:undefined,
          phoneNumber:undefined,
          maritalStatus:undefined,
          fertilityStatus:undefined,
          healthStatus:undefined,
          healthStatusRemarks:undefined,
          nativePlace:undefined,
          registeredType:undefined,
          personnelType:undefined,
          practiceQualification:undefined,
          firstWorkingDate:undefined,
          professionalTitle:undefined,
          graduationSchool:'',
          registeredAddress:'',
          addressNow:'',
          major:'',
        },
        inductionTreatmentDO: {},
        inductionDeclare: {},
        inductionEducationList: [],
        inductionWorkList: [],
        inductionFamily: [],
        specialNote: ''
      },
      idTypes: undefined,
      maritalStatuses: undefined,
      fertilityStatuses: undefined,
      healthStatuses: undefined,
      registeredTypes: undefined,
      personneslTypes: undefined,
      highestEducations: undefined,
      relationships: undefined,
      sexs: [
        { value: 1, name: vm.$t('user.sex.1') },
        { value: 0, name: vm.$t('user.sex.0') }
      ],
      socialSecuritys: [
        { value: 1, name: vm.$t('datapermission.induction.socialSecuritys.1') },
        { value: 0, name: vm.$t('datapermission.induction.socialSecuritys.0') }
      ],
      accumulationFunds: [
        { value: 1, name: vm.$t('datapermission.induction.accumulationFunds.1') },
        { value: 0, name: vm.$t('datapermission.induction.accumulationFunds.0') }
      ],

      natives: this.$t('datapermission.induction.native'),
      show:false,
      brokerages:[],
    }
  },


  mounted() {
    this.initInduction()
    this.queryDueTimeList()
    this.initBrokerage()


  },

  computed: {
    isShowDetail(){
      return true;
    },
    isShowOther(){
      return true;
    },
    isShowAll(){
      return true;
    },
    personneslTypesSelect(){
      let arr = [];
      this.personneslTypes.forEach(data=>{
        if(data.wordKey == this.companyId){
          arr = data.children;
        }
      });
      return arr;
    },
    outImage() {
      console.log('this.inductionBasicImage', this.inductionBasicImage)
      if (this.inductionInfo.id && this.inductionBasicImage.length == 0) {
        let data = {
          fileId: ''
        }

        data.fileId = this.inductionInfo.inductionBasicDO.photoAddress != '~' ? this.inductionInfo.inductionBasicDO.photoAddress : ''
        console.log('显示图片:{}', data)
        return data
      } else {
        let data = this.inductionBasicImage.find(o => o.type == 1)
        if (data && data.fileId) {
          this.form.outImage = data.fileId
        }
        console.log('显示图片2:{}', data)
        return data
      }
    }
  },
  watch: {
    companyId: function() {
      console.log('asdasd')

      this.getDeps(this.companyId)
    },
    depId: function() {
      this.postId = undefined
      this.getPost(this.depId)
    },

  },
  methods: {
    getArrayList(value){
      if(value == '~'){
        return value;
      }
      try{
        let arr = JSON.parse(value)
        return arr[0]+" / "+arr[1];
      }catch (e) {
        return '~'
      }
    },
    //获取日期
    onChangeDate(index){
      if(this.educationDate[index][0]){
        this.form.inductionEducationList[index].educationDate = this.educationDate[index][0]+','+this.educationDate[index][1]
      }else{
        this.form.inductionEducationList[index].educationDate = null;
      }
    },
    initBrokerage(){
      BrokerageApi.selectAll().then(res=>{
        if(res.code == 1){
          this.brokerages = res.data
          console.log("-----<<<<>>>>",this.brokerages)
        }
      })
    },
    salaryChange(value){
      if(this.userInfo){
        console.log(value,this.userInfo.basepay,value != parseFloat(this.userInfo.basepay.replace(/\$\s?|(,*)/g, '')))
        this.show =  (value != parseFloat(this.userInfo.basepay.replace(/\$\s?|(,*)/g, '')))
      }else{
        this.show = false
      }
    },
    initInduction(){
      this.inductionId = this.userInfo.inductionId
      if(this.inductionId != undefined && this.inductionId!=0){
        this.$loading.show()
        Api.selectDetail(this.inductionId).then(res => {
          if(res.code == 1){
            console.log('res.data',res.data)
            this.inductionInfo = res.data
            this.editInit()
          }
        }).finally(()=>{
          this.$loading.hide()
        })
      }else{
        this.editInit()
      }
    },
    removeNull(option) { //删除是null值的属性
      if (!option) {
        return
      }
      for (var attr in option) {
        if (option[attr] === null) {
          option[attr] = undefined
          continue
        }
        if (typeof (option[attr]) == 'object') {
          this.removeNull(option[attr])
        }
      }
    },
    editInit() {
      console.log('this.oldValu11212e', this.inductionInfo)
      if (this.inductionInfo.id != undefined) {
        let fromInfo = JSON.parse(JSON.stringify(this.inductionInfo).replace(/\"~\"/g, null).replace(/\"0\"/g, null))
        this.$set(this.$data,'form',fromInfo);
        this.removeNull(this.form)
        if(this.form.inductionEducationList.length > 0){
          this.form.inductionEducationList.forEach((item,index)=>{
            if(item.educationDate){
              let educationDate =  item.educationDate.split(',');
              this.educationDate.push(educationDate)
            }else{
              this.educationDate.push([])
            }
          })
        }
        if (this.form.inductionInvitationDO.proposedEntryDate) {
          this.form.inductionInvitationDO.proposedEntryDate = moment(this.form.inductionInvitationDO.proposedEntryDate).format('YYYY/MM/DD')
        } else {
          this.form.inductionInvitationDO.proposedEntryDate = undefined
        }
        this.companyId = this.form.inductionInvitationDO.companyId
        this.form.inductionInvitationDO.postId = this.inductionInfo.inductionInvitationDO.postId
        this.form.inductionInvitationDO.departmentId = this.inductionInfo.inductionInvitationDO.departmentId
        this.depId = this.inductionInfo.inductionInvitationDO.departmentId
        this.inductionInfo.inductionBasicDO.lunarCalendar == 1 ? this.isLunarCalendar = true : this.isLunarCalendar = false
        if (this.inductionInfo.inductionBasicDO.birthday != '~') {
          this.form.inductionBasicDO.birthday = moment(this.inductionInfo.inductionBasicDO.birthday).format('YYYY-MM-DD')
        } else {
          this.form.inductionBasicDO.birthday = undefined
        }
        this.form.outImage = this.inductionInfo.inductionBasicDO.photoAddress

        if (this.inductionInfo.inductionBasicDO.firstWorkingDate != '~') {
          this.form.inductionBasicDO.firstWorkingDate = moment(this.inductionInfo.inductionBasicDO.firstWorkingDate).format('YYYY-MM-DD')
        } else {
          this.form.inductionBasicDO.firstWorkingDate = undefined
        }
        this.form.inductionTreatmentDO.socialSecurity = parseInt(this.inductionInfo.inductionTreatmentDO.socialSecurity)
        this.form.inductionTreatmentDO.accumulationFund = parseInt(this.inductionInfo.inductionTreatmentDO.accumulationFund)


        let inductionDeclare = this.inductionInfo.inductionDeclare
        console.log('inductionDeclare', this.form.inductionTreatmentDO)

        if (this.form.inductionTreatmentDO.declares == 1) {
          if (inductionDeclare.housingLoanInterest == 1) {
            this.checkedListOne[0] = '1'
          } else if (inductionDeclare.housingRent == 1) {
            this.checkedListOne[0] = '2'
          }
          if (inductionDeclare.continuingEducation == 1) {
            this.checkedListTwo.push('3')
          }
          if (inductionDeclare.childrensEducation == 1) {
            this.checkedListTwo.push('4')
          }
          if (inductionDeclare.supportTheElderly == 1) {
            this.checkedListTwo.push('5')
          }
          if (inductionDeclare.seriousIllness == 1) {
            this.checkedListTwo.push('6')
          }
        } else {
          this.changDeclare = true
        }
      }
      //初始化值
      this.initUserToForm();


    },
    initUserToForm(){
      this.companyId = this.userInfo.companyId;
      this.form.inductionInvitationDO.postId = this.userInfo.postId;
      this.depId = this.userInfo.depId;
      this.form.inductionInvitationDO.departmentId = this.userInfo.depId;
      this.inductionBasicImage = [];
      this.inductionBasicImage.push({
        type: 1,
        fileId: this.userInfo.headimg,
        fileName: "头像.png"
      })
      this.form.inductionTreatmentDO.bank = this.form.inductionTreatmentDO.bank && this.form.inductionTreatmentDO.bank != '~'?this.form.inductionTreatmentDO.bank:this.userInfo.blankname == '~'?undefined:this.userInfo.blankname
      this.form.inductionTreatmentDO.bankAddress = this.form.inductionTreatmentDO.bankAddress && this.form.inductionTreatmentDO.bankAddress != '~'?this.form.inductionTreatmentDO.bankAddress:this.userInfo.branch == '~'?undefined:this.userInfo.branch
      this.form.inductionTreatmentDO.bankNumber = this.form.inductionTreatmentDO.bankNumber && this.form.inductionTreatmentDO.bankNumber != '~'?this.form.inductionTreatmentDO.bankNumber:this.userInfo.blankcode == '~'?undefined:this.userInfo.blankcode
      this.form.inductionBasicDO.idNumber = this.userInfo.idcard;
      this.form.inductionBasicDO.idType = this.form.inductionBasicDO.idType && this.form.inductionBasicDO.idType != '~'?this.form.inductionBasicDO.idType:"1bff63ea63a19b9b";
      this.form.inductionBasicDO.nation = this.form.inductionBasicDO.nation && this.form.inductionBasicDO.nation != '~'?this.form.inductionBasicDO.nation:"汉族";
      this.form.inductionBasicDO.phoneNumber = this.userInfo.phone;
      this.form.inductionInvitationDO.companyId= this.userInfo.companyId;
      this.form.inductionInvitationDO.name= this.userInfo.zhname;
      this.form.inductionBasicDO.nameEn= this.userInfo.userName;
      this.form.inductionInvitationDO.sex= this.userInfo.sex;
      this.form.inductionBasicDO.birthday= this.userInfo.birthTime;
      this.form.inductionBasicDO.highestEducation= this.userInfo.education;
      this.isLunarCalendar= this.userInfo.birthtype == 2;
      let employeeVO = JSON.parse(JSON.stringify(this.userInfo).replace(/\"~\"/g, null).replace(/\"0\"/g, null))
      this.form.emoloyeeVO = Object.assign(employeeVO,{})
      console.log(this.form.emoloyeeVO)
      this.removeNull(employeeVO)
      this.form.emoloyeeVO.reporter = this.form.emoloyeeVO.reporter?this.form.emoloyeeVO.reporter:undefined
      if(this.form.emoloyeeVO.trialdate != '~' && this.form.emoloyeeVO.trialdate){
        console.log("实习期日期",this.form.emoloyeeVO.trialdate)
        this.form.emoloyeeVO.trialdate = JSON.parse(this.form.emoloyeeVO.trialdate)
        console.log("实习期日期",this.form.emoloyeeVO.trialdate)
      }
      if(this.form.emoloyeeVO.practicedate != '~' && this.form.emoloyeeVO.practicedate){
        console.log("实习期日期",this.form.emoloyeeVO.practicedate)
        this.form.emoloyeeVO.practicedate = JSON.parse(this.form.emoloyeeVO.practicedate)
        console.log("实习期日期",this.form.emoloyeeVO.practicedate)
      }
      console.log("dsafasfsd",this.form.emoloyeeVO)
      this.initEducation()
      this.initWork()
      this.initFamily()

    },
    getDataDraft() {
      return new Promise((resolve, reject) => {
        console.log('form', this.form)
        this.$refs.ruleForm.clearValidate()
        resolve(this.form)
      })
    },
    getData() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(valid => {
          console.log('valid', valid)
          if (valid) {
            console.log('form', this.form)
            try {
              if(this.form.emoloyeeVO.trialdate != '~' && this.form.emoloyeeVO.trialdate){
                this.form.emoloyeeVO.trialdate = JSON.stringify([this.form.emoloyeeVO.trialdate[0].format('YYYY-MM-DD'),this.form.emoloyeeVO.trialdate[1].format('YYYY-MM-DD')])
              }
              if(this.form.emoloyeeVO.practicedate != '~' && this.form.emoloyeeVO.practicedate){
                console.log("实习期日期",this.form.emoloyeeVO.practicedate)
                this.form.emoloyeeVO.practicedate = JSON.stringify([this.form.emoloyeeVO.practicedate[0].format('YYYY-MM-DD'),this.form.emoloyeeVO.practicedate[1].format('YYYY-MM-DD')])
                console.log("实习期日期",this.form.emoloyeeVO.practicedate)
              }
            }catch (error){
              console.log(error)
            }
            if(this.form.inductionBasicDO.maritalStatus == 1){
              let item = this.form.inductionFamily.find(o=>o.relationship == 3);
              if(!item){
                this.$message.warning("家庭成员类型必须包含配偶!")
                reject()
                return false
              }
            }
            resolve(this.form)
          } else {
            console.log('error submit!!')
            reject()
            return false
          }
        })
      })
    },

    //取消
    cancelInduction() {

    },
    //保存为草稿
    saveInduction() {

    },
    //提交
    submitInduction() {

    },
    changContact(index) {
      this.form.inductionFamily.forEach((item, index) => {
        item.emergencyContact = false
      })
      let induction = this.form.inductionFamily[index]
      induction.emergencyContact = true
      this.form.inductionFamily[index] = induction
      console.log('induction', this.inductionFamily)
    },
    deleteEducation(index) {
      this.form.inductionEducationList.forEach((item, idx) => {
        if (idx === index) {
          this.form.inductionEducationList.splice(idx, 1)
        }
      })
    },
    addEducation() {
      this.form.inductionEducationList.push({
        educationDate: undefined,
        school: undefined,
        major: undefined,
        education: undefined
      })
    },
    initEducation() {
      if (this.inductionInfo.id) {

      } else {
        for (let i = 0; i < 2; i++) {
          this.addEducation()
        }
      }
    },
    deleteWork(index) {
      this.form.inductionWorkList.forEach((item, idx) => {
        if (idx === index) {
          this.form.inductionWorkList.splice(idx, 1)
        }
      })
    },
    addWork() {
      if(!this.form.inductionWorkList || this.form.inductionWorkList == '~'){
        this.form.inductionWorkList = []
      }
      this.form.inductionWorkList.push({
        workDate: undefined,
        companyName: undefined,
        department: undefined,
        post: undefined,
        witnessContact: undefined,
        orderNumber: undefined
      })
    },
    initWork() {
      if (this.inductionInfo.id) {
        if(!this.form.inductionWorkList || this.form.inductionWorkList == '~'){
          this.form.inductionWorkList = []
          for (let i = 0; i < 2; i++) {
            this.addWork()
          }
        }
      } else {
        for (let i = 0; i < 2; i++) {
          this.addWork()
        }
      }
    },
    deleteFamily(index) {
      this.form.inductionFamily.forEach((item, idx) => {
        if (idx === index) {
          if (item.emergencyContact = true) {
            this.form.inductionFamily.forEach((ite, id) => {
              if (id === 0) {
                ite.emergencyContact = true
              }
            })
          }
          this.form.inductionFamily.splice(idx, 1)
        }
      })
    },
    addFamily() {
      this.form.inductionFamily.push({
        name: undefined,
        relationship: undefined,
        companyPost: undefined,
        contactInformation: undefined,
        emergencyContact: false,
        orderNumber: undefined
      })
    },
    initFamily() {
      if (this.inductionInfo.id) {

      } else {
        for (let i = 0; i < 2; i++) {
          this.addFamily()
        }
        this.form.inductionFamily.forEach((item, index) => {
          if (index == 0) {
            item.emergencyContact = true
          }
        })
      }
    },


    getImageUrl(fileId) {
      console.log('fileIdfileIdfileId', fileId)
      let url = this.$util.getFileUrl(fileId)
      return url
    },
    uploadImgSuccess(file, fileId, number) {
      let images = this.inductionBasicImage.find(o => o.type == number)
      if (images) {
        images.fileId = fileId
        images.fileName = file.name
      } else {
        this.inductionBasicImage.push({
          type: number,
          fileId: fileId,
          fileName: file.name
        })
      }
      console.log('number', fileId)
      this.form.outImage = fileId
      console.log('number', this.form.outImage)
      if (number == 1) {
        this.$refs.ruleForm.validateField('outImage')
      } else {
        this.$refs.ruleForm.validateField('planImage')
      }


    },
    //选择专项扣除(住房贷款和租金)
    changeDeclareIdOne(e) {
      if (this.checkedListOne.length > 1) {
        this.checkedListOne.splice(0, 1)
      }
      if (e.length > 0) {
        this.changDeclare = false
      }
      if (this.checkedListOne[0] == 1) {
        this.form.inductionDeclare.housingLoanInterest = 1
        this.form.inductionDeclare.housingRent = 0
      } else {
        this.form.inductionDeclare.housingLoanInterest = 0
        this.form.inductionDeclare.housingRent = 1
      }
    },
    //选择专项扣除(继续教育、子女教育、赡养老人、大病)
    changeDeclareIdTwo(e) {
      if (e.length > 0) {
        this.changDeclare = false
      }
      let Declares = {
        continuingEducation: 0,
        childrensEducation: 0,
        supportTheElderly: 0,
        seriousIllness: 0
      }
      this.checkedListTwo.forEach((ite, ind) => {
        if (ite == 3) {
          Declares.continuingEducation = 1
        } else if (ite == 4) {
          Declares.childrensEducation = 1
        } else if (ite == 5) {
          Declares.supportTheElderly = 1
        } else if (ite == 6) {
          Declares.seriousIllness = 1
        }
      })
      this.form.inductionDeclare.continuingEducation = Declares.continuingEducation
      this.form.inductionDeclare.childrensEducation = Declares.childrensEducation
      this.form.inductionDeclare.supportTheElderly = Declares.supportTheElderly
      this.form.inductionDeclare.seriousIllness = Declares.seriousIllness
      console.log('this.checkedListTwo', this.checkedListTwo)
    },
    //根据数据字典查询证件类型
    queryDueTimeList() {
      let pathMap = {
        idTypes: 'system.induction.id_type',
        maritalStatuses: 'system.induction.marital_status',
        fertilityStatuses: 'system.induction.fertility_status',
        healthStatuses: 'system.induction.health_status',
        registeredTypes: 'system.induction.registered_type',
        personneslTypes: 'system.induction.personnel_type',
        highestEducations: 'system.induction.highest_education',
        relationships: 'system.induction.relationship'
      }
      let this_ = this
      if(this.isOut){
        Api.getInductionDatadic(pathMap).then(res => {
          if (res.data) {
            this_.idTypes = res.data.idTypes
            this_.maritalStatuses = res.data.maritalStatuses
            this_.fertilityStatuses = res.data.fertilityStatuses
            this_.healthStatuses = res.data.healthStatuses
            this_.registeredTypes = res.data.registeredTypes
            this_.personneslTypes = res.data.personneslTypes
            this_.highestEducations = res.data.highestEducations
            this_.relationships = res.data.relationships
          }
        })
      }else{
        getInductionDatadic(pathMap).then(res => {
          if (res.data) {
            this_.idTypes = res.data.idTypes
            this_.maritalStatuses = res.data.maritalStatuses
            this_.fertilityStatuses = res.data.fertilityStatuses
            this_.healthStatuses = res.data.healthStatuses
            this_.registeredTypes = res.data.registeredTypes
            this_.personneslTypes = res.data.personneslTypes
            this_.highestEducations = res.data.highestEducations
            this_.relationships = res.data.relationships
          }
        })
      }

    },
    //未申报过
    changDeclares() {
      this.changDeclare = !this.changDeclare
      this.form.inductionTreatmentDO.declares = this.changDeclare
      if (this.changDeclare) {
        this.checkedListTwo = [],
          this.checkedListOne = [],
          this.form.inductionDeclare.childrensEducation = 0
        this.form.inductionDeclare.continuingEducation = 0
        this.form.inductionDeclare.housingLoanInterest = 0
        this.form.inductionDeclare.housingRent = 0
        this.form.inductionDeclare.seriousIllness = 0
        this.form.inductionDeclare.supportTheElderly = 0
      }
    },
    //阴历和阳历切换
    onChangeBox(e) {
      if (e.target.checked) {
        this.form.inductionBasicDO.lunarCalendar = 1
        this.isLunarCalendar = true
      } else {
        this.form.inductionBasicDO.lunarCalendar = 0
        this.isLunarCalendar = false
      }
    },
    //选择拟入职时间
    onChangeEntryDate() {
      let proposedEntryDate = this.form.inductionInvitationDO.proposedEntryDate
      if (proposedEntryDate != undefined) {
        this.form.inductionBasicDO.proposedEntryDate = moment(proposedEntryDate).format('YYYY-MM-DD')
      }
    },
    //选择生日
    onChangeBirthday() {
      let birthday = this.form.inductionBasicDO.birthday
      if (birthday != undefined) {
        this.form.inductionBasicDO.birthday = moment(birthday).format('YYYY-MM-DD')
        this.$refs.ruleForm.validateField('inductionBasicDO.birthday')
      } else {
        this.form.inductionBasicDO.birthday = undefined
        this.$refs.ruleForm.validateField('inductionBasicDO.birthday')
      }
    },
    //首次参加工作时间
    firstWorkingDateChange() {
      let firstWorkingDate = this.form.inductionBasicDO.firstWorkingDate
      if (firstWorkingDate != undefined) {
        this.form.inductionBasicDO.firstWorkingDate = moment(firstWorkingDate).format('YYYY-MM-DD')
      }
    },
    //获取身份证类型
    /* getIdType(e) {
       console.log('this.form.inductionBasicDO.idType',this.form.inductionBasicDO.idType)
     },*/
    //获取部门信息
    getDeps(companyId) {
      let this_ = this
      console.log('companyId', companyId)
      if (!this_.inductionInfo.id) {
        // this.depId = undefined
        // this.postId = undefined
      }
      this_.posts = []
      if (!this.isOut) {
        DepApi.selectDepByCompanyId(companyId).then(res => {
          if (res.code == 1) {
            this_.deps = res.data.filter((item) => {
              return item.id != companyId
            })
          }
        })
      }

      console.log('this.deps', this_.deps)
    },
    getCompany() {
      this.postId = undefined
      this.depId = undefined
      this.form.inductionInvitationDO.companyId = this.companyId
      this.form.inductionInvitationDO.postId = undefined;
    },
    selectPost() {

    },
    selectdeps() {
      this.$nextTick(()=>{
        this.form.inductionInvitationDO.postId = undefined;
        this.form.inductionInvitationDO.departmentId = this.depId
      })
    },

    //获取职位信息
    getPost(depId) {
      if (!this.inductionInfo) {
        this.form.setFieldsValue({ postId: undefined })
      }
      if (!this.isOut) {
        PostApi.selectPostBydepId(depId).then(res => {
          if (res.code == 1) {
            this.posts = res.data
          }
        })
      }
    }
  }


}
</script>

<style scoped lang="less">

#inputForm {
  display: flex;
  justify-content: center;
  background: #FFFFFF;
  border-radius: 10px 10px 4px 4px;

  .topTitle {
    height: 25px;
    font-size: 18px;
    color: #333333;
    line-height: 25px;
    font-weight: 600;
  }

  .values {
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 600;
  }

  .hgandleInduction_content {
    min-width: 1091px;
    padding-top: 30px;
    padding-bottom: 52px;
  }
}

.text_value{
  font-size: 12px;
  color: #333333;
  padding-left: 5px;
}

</style>